import { TranslateService } from '@ngx-translate/core';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, FormControl, FormGroupDirective, NgForm, UntypedFormBuilder } from '@angular/forms';
import { LoginService } from '../../services/login/login.service';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import { markFormGroupTouched } from 'src/app/controls/functions/shared-functions';
import { getInvalidFields } from 'src/app/functions/shared-functions';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  providers: [
    LoginService
  ]
})
export class ForgotPasswordComponent implements OnInit {

  isOTPSendSuccessfully = false;
  resetPasswordRequest = false;
  isOTPVariedSuccessfully = false;
  userId;
  OTP;
  newPassword;
  countdown: number;
  hide: boolean = false;
  hide_confirm_pass: boolean = false;
  isLoaded = false;
  isSubmitted = false;
  userPostResData;
  isChangePasswordClicked = false;
  userValid;
  userLogin = false;
  forgetPassword = false;
  isLinkSendSuccessfully = true;
  invalid = false;
  max_length = 10;
  masters: any = {};
  pass_pattern = '/(?=.*\W)(?=.*\d)/';
  password_form: UntypedFormGroup;
  message: any = {};
  email_pattern = "^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$";


  matcher = new ErrorStateMatcher();
  mobileNumber: any;
  emailId: any;
  loginId: any;
  validType;
  request_to_reset: any;
  constructor(private login_service: LoginService,
    private notification_svc: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<ForgotPasswordComponent>,
    private translate: TranslateService,
    private change_detector: ChangeDetectorRef,
    private fb: UntypedFormBuilder) {
    this.init();
  }

  ngOnInit() {
    if (this.data) {
      this.masters = this.data;
    }
  }
  init() {
    this.password_form = this.fb.group(
      {
        loginId: ["", Validators.required],
        password: ["", [Validators.minLength(6), Validators.pattern(/(?=.*\W)(?=.*\d)/)]],
        newPassword: [""],
        otp: [""],
      },
      {
        validator: this.checkPassword
      }
    );
  }

  countryCodeChanged(ev) {
    if (ev && ev.mobileNumberLength) {
      this.max_length = ev.mobileNumberLength;
    }
  }

  onResetPassword(form) {
    this.isLoaded = true;
    this.userId = form.value.userId;

    if (this.userId == "") {

      this.invalid = true;


    }
    else {
      this.invalid = false;
    }
    if (!this.isOTPSendSuccessfully) {
      this.login_service.forgotPassword(this.userId).subscribe(resData => {

        if (resData['status'] == true) {
          this.isOTPSendSuccessfully = true;

          this.isLinkSendSuccessfully = false;
          this.isLoaded = false;
          this.notification_svc.success(resData['message'], 'Close', 5000)
        }
        else {
          this.notification_svc.error(resData['message'], "Close", 3000)
        }

      },
        errorData => {
          this.notification_svc.error(errorData, "Close", 3000)
        }

      );
    }
    else {

    }
  }
  checkPassword(group: UntypedFormGroup) {
    let pass = group.get('password').value;
    let confirm_pass = group.get('newPassword').value;
    if (pass != confirm_pass) {
      group.get('newPassword').setErrors({
        notSame: true
      })
    }
    else {
      group.get('newPassword').clearValidators();
    }
    // group.get('newPassword').updateValueAndValidity();
    return pass === confirm_pass ? null : { notSame: true };
  }
  save() {
    if (this.password_form.valid) {
      let obj = this.password_form.getRawValue();
      this.request_to_reset = obj;
      console.log(obj)
      this.login_service.resetPassSendOtp(obj).subscribe(resData => {
        if (resData['status'] == true) {
          if (resData && resData['data']) {
            this.message = resData['data']
          }
          this.isOTPSendSuccessfully = true;
          this.password_form.controls.otp.setValidators([Validators.required]);
          this.notification_svc.success(resData['message'], 'Close', 5000)
        }
        else {
          this.notification_svc.error(resData['message'], "Close", 3000)
        }
      }, err => {
        this.notification_svc.error(err['message'], "Close", 3000)
      });
    }
    else {
      getInvalidFields(this.password_form, this.translate, this.notification_svc, "FORGOT_PASSWORD.");
      markFormGroupTouched(this.password_form);
    }
  }

  verifyOTP() {
    if (this.password_form.valid) {
      let obj = this.password_form.getRawValue();
      this.login_service.resetPassVerifyOtp(obj).subscribe(res => {
        if (res && res['status']) {
          this.notification_svc.success(res['message'], "Close", 5000)
          this.isOTPVariedSuccessfully = true;
          this.password_form.controls.password.setValidators([Validators.required])
          this.password_form.controls.newPassword.setValidators([Validators.required])
        }
      })
    }
    else {
      getInvalidFields(this.password_form, this.translate, this.notification_svc, "FORGOT_PASSWORD.");
      markFormGroupTouched(this.password_form);
    }
  }
  changePassword() {
    if (this.password_form.valid) {
      let obj = this.password_form.getRawValue();
      this.login_service.newPassChange(obj).subscribe(res => {
        if (res && res['status']) {
          this.notification_svc.success(res['message'], "Close", 5000)
          this.dialogRef.close();
        }
        else {
          this.notification_svc.error(res['message'], "Close", 5000)
        }
      })
    }
    else {
      getInvalidFields(this.password_form, this.translate, this.notification_svc, "FORGOT_PASSWORD.");
      markFormGroupTouched(this.password_form);
    }
  }
  resendOTP() {
    this.startCountdown(30);
    let obj = this.password_form.getRawValue();
    this.login_service.resetPassSendOtp(obj).subscribe(resData => {
      if (resData['status'] == true) {
        if (resData && resData['data']) {
          this.message = resData['data']
        }
        this.isOTPSendSuccessfully = true;
        this.password_form.controls.otp.setValidators([Validators.required]);
        this.notification_svc.success(resData['message'], 'Close', 5000)
      }
      else {
        this.notification_svc.error(resData['message'], "Close", 3000)
      }
    }, err => {
      this.notification_svc.error(err['message'], "Close", 3000)
    });
  }
  startCountdown(countdown) {
    this.countdown = countdown;

    const interval = setInterval(() => {
      this.countdown--;

      if (this.countdown < 0) {
        clearInterval(interval);
      }
    }, 1000);
  }
  close() {
    this.dialogRef.close()
  }
}
